import angular from 'angular';
import components from './components';
import educationQualifications from './educationQualifications';

export default angular
  .module('scenes.educationQualifications', [components])
  .component('educationQualifications', educationQualifications).name;
